(() => {
  if (window.__llcTheatreLoader) { window.__llcTheatreLoader.scan(document); return; }
  const selector = '[data-llc-about-finish]';
  let modulePromise;
  function init(root) {
    root._llcCleanup?.();
    const controller = new AbortController();
    const { signal } = controller;
    const queries = [matchMedia('(min-width:1024px)'),matchMedia('(pointer:fine)'),matchMedia('(prefers-reduced-motion:reduce)')];
    const connection = navigator.connection;
    const button = root.querySelector('[data-motion-toggle]');
    let off = new URLSearchParams(location.search).get('motion') === 'off';
    let cleanup, activeMount, generation = 0, disposed = false;
    async function configure() {
      const version = ++generation;
      activeMount?.abort();
      const mountController = new AbortController(); activeMount = mountController;
      cleanup?.(); cleanup = undefined;
      root.classList.add('lite');
      root.dataset.motionMode = 'lite';
      button.textContent = off ? root.dataset.resume : root.dataset.pause;
      button.setAttribute('aria-pressed', String(off));
      const capable = queries[0].matches && queries[1].matches && !queries[2].matches && !connection?.saveData && root.dataset.storyMotion !== 'false';
      button.hidden = !capable;
      if (!capable || off) return;
      try {
        modulePromise ||= import(new URL(root.dataset.engineUrl,document.baseURI).href);
        const engine = await modulePromise;
        if (disposed || version !== generation) return;
        const mounted = await engine.mount(root, mountController.signal);
        if (disposed || version !== generation) mounted?.();
        else cleanup = mounted;
      } catch (error) {
        if (disposed || version !== generation) return;
        modulePromise = undefined;
        root.classList.add('lite');
        root.dataset.motionMode = 'fallback';
        console.warn('About story motion unavailable; static content retained.', error);
      }
    }
    button.addEventListener('click', () => { off = !off; configure(); }, { signal });
    queries.forEach(q => q.addEventListener('change', configure, { signal }));
    connection?.addEventListener('change', configure, { signal });
    root._llcCleanup = () => { disposed = true; generation++; activeMount?.abort(); cleanup?.(); controller.abort(); };
    configure();
  }
  const roots = scope => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  const scan = scope => roots(scope).forEach(init);
  window.__llcTheatreLoader = { scan };
  scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:reorder', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => roots(e.target).forEach(r => r._llcCleanup?.()));
})();
